var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FClipboard',{attrs:{"text":_vm.text},on:{"success":_vm.handleSuccess}},[_c('span',{staticStyle:{"color":"#07c160"}},[_vm._v("Copy")])])}
var staticRenderFns = []

export { render, staticRenderFns }